import { AxiosProgressEvent } from 'axios';
import { API_HOST } from 'src/config-global';
import { uploadWorker } from 'src/services/FileUploader/uploadWorker';
import { axios } from 'src/utils/axios';

export type UploadImageResponse = {
  url: string;
  mimeType: string;
  size: number;
};

export async function uploadPublicFile(
  file: File,
  onProgress?: (percentage: number, speed?: number) => void,
): Promise<UploadImageResponse> {
  const fd = new FormData();
  fd.append('file', file);

  const { data } = await axios.post<UploadImageResponse>(
    `/assets/upload/file/public`,
    fd,
    {
      onUploadProgress: (progressEvent) => {
        onProgress?.(
          (progressEvent.loaded / (progressEvent.total || 0)) * 100,
          progressEvent.rate,
        );
      },
    },
  );

  return data;
}

export type IFile = {
  createdBy: string;
  workspace: string;
  mimeType: string;
  size: number;
  name: string;
  _id: string;
  createdAt: string;
  updatedAt: string;
};

export async function uploadPrivateFile(
  file: File,
  onProgress?: (percentage: number, speed?: number) => void,
): Promise<IFile> {
  return uploadWorker<IFile>(file, {
    onProgress: (data) => {
      onProgress?.(data.progress, data.speed);
    },
    endpoints: {
      start: `${API_HOST}/files/multipart/start/upload/private`,
      getSignedUrls: `${API_HOST}/files/multipart/get-signed-urls/upload/private`,
      finalize: `${API_HOST}/files/multipart/finalize/upload/private`,
    },
  });
}

export async function getPrivateFile(
  id: string,
  onProgress?: (progressEvent: AxiosProgressEvent) => void,
): Promise<File> {
  const { data } = await axios.get<File>(`/files/download?id=${id}`, {
    responseType: 'blob',
    onDownloadProgress: (progressEvent) => {
      onProgress?.(progressEvent);
    },
  });

  return data;
}

export async function getPublicFile(
  id: string,
  onProgress?: (progressEvent: AxiosProgressEvent) => void,
): Promise<File> {
  const { data } = await axios.get<File>(
    `/files/download/public-doc?id=${id}`,
    {
      responseType: 'blob',
      onDownloadProgress: (progressEvent) => {
        onProgress?.(progressEvent);
      },
    },
  );

  return data;
}

export * as AssetsRequests from './assets';
